import theme from '../themes/default'

const screenWidth = window.innerWidth

export default {
  wrap: {
    // height: '50px',
    // position: 'relative',
    'z-index': '99',
  },
  'swiper-container': {
    width: 'calc(100% - 39px)',
    height: '100%',
    background: '#614D4A',
    position: 'relative',
    overflow: 'hidden',
    'list-style': 'none',
    padding: '0',
    'z-index': '1',
  },
  'sub-swiper': {
    width: '100%',
    background: '#65524f',
  },
  'slide-block-wrap': {
    width: 'initial',
    height: 'initial',
    '& a': {
      color: '#fff',
    },
  },
  'slide-block': {
    color: '#fff',
    height: '50px',
    '& > div': {
      display: 'flex',
      height: '100%',
      'min-height': '50px',
      'align-items': 'center',
      padding: '0 15px 0px 20px',
    },
    'text-align': 'center',
  },
  'swiper-slide-active': {
    'border-bottom': '3px solid #D5AD40',
  },
  'd-none': {
    display: 'none !important',
  },
  'nav-swiper-menu': { // ! <-----------------------按鈕
    // display: 'inline-block',
    // top: '0',
    // right: '0',
    width: '38px',
    height: '50px',
    textAlign: 'center',
    lineHeight: '50px',
    background: 'rgb(97, 77, 74)',
    // margin: '0 auto',
    // position: 'absolute',
    overflow: 'hidden',
    // 'z-index': '11',
    'border-left': '1px solid white',
    'border-bottom': '1px solid white',
  },
  'swiper-container-stack-menu-expanded': {
    flex: 1,
    width: '100%',
    // 'padding-right': '39px',
    background: 'rgb(97, 77, 74)',
    color: 'white',
    'z-index': '10',
    display: 'inline-block',
    'overflow-y': 'scroll',
    'overflow-x': 'hidden',
    position: 'fixed',
    '& .title': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'spaceBetween',
    },
    'max-height': 'calc(100%)',
  },
  'nav-caret': {
    transition: '0.5s',
    '-webkit-transition': '0.5s',
  },
  'swiper-container-stack-menu-hidden': {
    width: 'calc(100% - 50px)',
    background: 'rgb(97, 77, 74)',
    height: '0px',
    'z-index': '2',
    overflow: 'hidden',
    display: 'inline-block',
    position: 'relative',
  },
  'stack-menu-item': {
    padding: '0 1%',
    display: 'inline-block',
    width: '31%',
    height: 'auto',
  },
}



// WEBPACK FOOTER //
// ./src/assets/styles/components/NavBarSwiper.js